// ############################ Imported from Old UI ###########################

export default function isSSNValid(ssn: string) {
  if (!ssn || !/^[0-9]{9}$/i.test(ssn)) {
    return false;
  }
  return true;
}
